/**
 * Monta string para Nominatim: só valores preenchidos, separados por vírgula
 * (sem rótulos tipo "CEP" ou "Brasil"). O país já é filtrado por countrycodes na API.
 *
 * @param {Object} parts
 * @param {{ includeNumber?: boolean }} [options]
 * @returns {string|null}
 */
export default function buildAddressSearchQuery(parts, options = {}) {
  if (!parts || typeof parts !== "object") return null;

  const includeNumber = options.includeNumber === true;

  const cepRaw = (parts.cep || "").replace(/\D/g, "");
  const estado = (parts.estado || "").trim();
  const cidade = (parts.cidade || "").trim();
  const bairroNome = (parts.bairroNome || "").trim();
  const logradouro = (parts.logradouro || "").trim();
  const numero = (parts.numero || "").trim();

  const hasCep = cepRaw.length >= 8;
  const cepFmt = hasCep
    ? `${cepRaw.slice(0, 5)}-${cepRaw.slice(5, 8)}`
    : "";

  /** Ordem fixa para o Nominatim: número, rua, bairro, cidade, CEP (só o que estiver preenchido). */
  /** @type {string[]} */
  const pieces = [];

  if (includeNumber && numero) pieces.push(numero);
  if (logradouro) pieces.push(logradouro);
  if (bairroNome) pieces.push(bairroNome);
  if (cidade) pieces.push(cidade);
  if (hasCep) pieces.push(cepFmt);

  const query = pieces.filter(Boolean).join(", ");
  if (!query.trim()) return null;

  const hasCidadeEstado = !!(cidade && estado);
  const hasStreetCity = !!(logradouro && cidade);
  const hasBairroCityState = !!(bairroNome && cidade && estado);

  if (
    !hasCep &&
    !hasCidadeEstado &&
    !hasStreetCity &&
    !hasBairroCityState
  ) {
    return null;
  }

  return query;
}
